/**
 * The p5 library source, fetched once per page and shared by every frame.
 *
 * Why the source and not a <script src> tag: sketch frames are sandboxed
 * with allow-scripts and no allow-same-origin, which puts them in an opaque
 * origin. In that state the browser refuses to load the subresource — the
 * script tag fails silently, p5 is never defined, and the sketch's setup()
 * is simply never called (nothing throws, because the sketch only *defines*
 * functions). Inlining the library into the frame document sidesteps that
 * entirely while keeping the sandbox intact.
 *
 * The fetch itself is normal and HTTP-cached, so this costs one request per
 * session regardless of how many sketches are on screen.
 */
const P5_URL = "/vendor/p5.min.js";

let cached: Promise<string> | null = null;

export function loadP5Source(): Promise<string> {
  cached ??= fetch(P5_URL).then((res) => {
    if (!res.ok) throw new Error(`Could not load p5 (${res.status})`);
    return res.text();
  });
  return cached;
}
